var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMoreVertical = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "More Vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "more",
    d: "M14.1395 22.8931C14.677 22.3525 15.2971 22.0822 16 22.0822C16.7028 22.0822 17.323 22.3525 17.8604 22.8931C18.3979 23.4337 18.6666 24.0575 18.6666 24.7645C18.6666 25.4714 18.3979 26.0952 17.8604 26.6358C17.323 27.1764 16.7028 27.4467 16 27.4467C15.2971 27.4467 14.677 27.1764 14.1395 26.6358C13.602 26.0952 13.3333 25.4714 13.3333 24.7645C13.3333 24.0575 13.602 23.4337 14.1395 22.8931ZM14.1395 14.9087C14.677 14.3681 15.2971 14.0978 16 14.0978C16.7028 14.0978 17.323 14.3681 17.8604 14.9087C18.3979 15.4493 18.6666 16.0731 18.6666 16.7801C18.6666 17.487 18.3979 18.1108 17.8604 18.6514C17.323 19.192 16.7028 19.4623 16 19.4623C15.2971 19.4623 14.677 19.192 14.1395 18.6514C13.602 18.1108 13.3333 17.487 13.3333 16.7801C13.3333 16.0731 13.602 15.4493 14.1395 14.9087ZM17.8604 10.667C17.323 11.2076 16.7028 11.4779 16 11.4779C15.2971 11.4779 14.677 11.2076 14.1395 10.667C13.602 10.1264 13.3333 9.50262 13.3333 8.79566C13.3333 8.08871 13.602 7.46493 14.1395 6.92432C14.677 6.38371 15.2971 6.1134 16 6.1134C16.7028 6.1134 17.323 6.38371 17.8604 6.92432C18.3979 7.46493 18.6666 8.08871 18.6666 8.79566C18.6666 9.50262 18.3979 10.1264 17.8604 10.667Z",
    fill: "#B7B6BF"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoreVertical, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/moreVertical.2dd23c9a.svg";
export { ForwardRef as ReactComponent };